export function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

export function assignNumberToSpans(textLayerRenderedEvent) {
    let ev = textLayerRenderedEvent;
    let pageEl = document.querySelector('div[data-page-number="' + ev.pageNumber + '"][class^="page"]');
    let textLayerEl = pageEl.querySelector(".textLayer");
    console.log("[@cruxcode/testpdfviewer] assignNumberToSpans", pageEl);
    let promise = new Promise((resolve, reject) => {
        let spanNumber = 1;
        for (let i = 0; i < textLayerEl.childNodes.length; i++) {
            if (textLayerEl.childNodes[i].nodeName == "SPAN") {
                textLayerEl.childNodes[i].divNumber = spanNumber;
                spanNumber++;
            }
        }
        resolve(spanNumber-1);
    });
    return promise;
}